// client/src/pages/UserRegistrationPage.js
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { register } from '../services/authService';
// import './UserRegistrationPage.css'; // Alte CSS entfernen
import {
    Layout, Row, Col, Card, Form, Input, Button, Checkbox, Typography, Alert, message,
    Divider
} from 'antd';
import { UserOutlined, MailOutlined, LockOutlined, ShopOutlined } from '@ant-design/icons';

const { Title, Paragraph } = Typography;

const UserRegistrationPage = () => {
    const navigate = useNavigate();
    const [form] = Form.useForm(); // Antd Form Hook
    // const [formData, setFormData] = useState({...}); // Wird durch Antd Form State ersetzt
    // const [formErrors, setFormErrors] = useState({}); // Wird durch Antd Form Validation ersetzt
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState(null); // Behalten für globale Fehler (API etc.)

    // Handler für Input-Änderungen nicht mehr nötig, Antd Form managed das.
    // const handleInputChange = (e) => { ... };

    // Validierungslogik wird in Form.Item rules verlagert.
    // const validateForm = () => { ... };

    const onFinish = async (values) => {
        // values enthält die Formulardaten von Antd Form
        const { name, email, password, acceptTerms } = values;

        // Validierung der Terms wird durch Form.Item rule gehandhabt.

        setIsSubmitting(true);
        setError(null);
        message.loading({ content: 'Registrierung wird verarbeitet...', key: 'userRegister' });

        try {
            const userData = {
                name,
                email,
                password,
                role: 'user' // Standard-Benutzerrolle
            };

            const result = await register(userData);

            if (result.success) {
                // message.success(...) // Optional: Nachricht kann bleiben oder entfernt werden
                // Weiterleitung zur neuen Seite
                navigate('/verify-email-notice');
            } else {
                 // Spezifische Fehlermeldung vom Backend anzeigen
                 setError(result.message || 'Registrierung fehlgeschlagen. E-Mail bereits vergeben?');
                 message.error({ content: `Fehler: ${result.message || 'Unbekannter Fehler'}`, key: 'userRegister' });
            }
        } catch (err) {
            console.error("Registrierungsfehler:", err);
             const errorMessage = err.response?.data?.message || err.message || 'Ein Netzwerkfehler ist aufgetreten.';
            setError(errorMessage);
             message.error({ content: `Fehler: ${errorMessage}`, key: 'userRegister' });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Layout style={{ minHeight: 'calc(100vh - 184px)', display: 'flex', justifyContent: 'center', alignItems: 'center', background: '#f0f2f5' }}>
            <Helmet>
                {/* <title>Benutzer Registrierung | Snus Finder</title> */}
                <title>Benutzerkonto erstellen | Snus Verzeichnis Deutschland</title>
                {/* <meta name="description" content="Registrieren Sie sich bei Snus Finder, um Bewertungen abzugeben und Ihre Lieblingsshops zu speichern." /> */}
                <meta name="description" content="Erstellen Sie ein Benutzerkonto für Snus Verzeichnis Deutschland." />
                 {/* Prevent indexing of the registration process page */}
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>

            <Row justify="center" align="middle" style={{ width: '100%' }}>
                <Col xs={24} sm={20} md={16} lg={12} xl={8}> {/* Etwas breiter als Login */}
                    <Card style={{ boxShadow: 'var(--box-shadow)' }}>
                         <div style={{ textAlign: 'center', marginBottom: '24px' }}>
                             <img src="/images/snus-finder-logo.svg" alt="Snus Finder Logo" style={{ height: '80px', marginBottom: '10px' }} />
                            <Title level={2}>Benutzer Registrierung</Title>
                            <Paragraph>
                                Erstellen Sie ein kostenloses Benutzerkonto.
                            </Paragraph>
                        </div>

                        {/* Hinweis für Shop-Besitzer */}
                        <Alert
                            message="Sind Sie Shop-Besitzer?"
                            description={<span>Wenn Ihr Shop bereits von einem Community-Mitglied gemeldet wurde, können Sie ihn nach der Registrierung <Link to="/shops">in der Shop-Liste suchen</Link> und beanspruchen, um ihn zu verwalten und aufzuwerten. Alternativ können Sie Ihren Shop <Link to="/register">hier direkt registrieren</Link>.</span>}
                            type="info"
                            showIcon
                            icon={<ShopOutlined />}
                            style={{ marginBottom: '24px' }}
                        />

                        {error && (
                            <Alert
                                message={error}
                                type="error"
                                showIcon
                                closable
                                onClose={() => setError(null)}
                                style={{ marginBottom: '24px' }}
                            />
                        )}

                        <Form
                            form={form}
                            name="user_registration"
                            onFinish={onFinish}
                            layout="vertical"
                            requiredMark={false}
                        >
                            <Form.Item
                                name="name"
                                label="Ihr Name"
                                rules={[{ required: true, message: 'Bitte geben Sie Ihren Namen ein.', whitespace: true }]}
                            >
                                <Input prefix={<UserOutlined />} placeholder="Max Mustermann" />
                            </Form.Item>

                            <Form.Item
                                name="email"
                                label="E-Mail-Adresse"
                                rules={[
                                    { required: true, message: 'Bitte geben Sie Ihre E-Mail-Adresse ein.' },
                                    { type: 'email', message: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.' }
                                ]}
                            >
                                <Input prefix={<MailOutlined />} placeholder="ihre@email.de" />
                            </Form.Item>

                            <Form.Item
                                name="password"
                                label="Passwort"
                                rules={[
                                    { required: true, message: 'Bitte geben Sie ein Passwort ein.' },
                                    { min: 8, message: 'Passwort muss mindestens 8 Zeichen lang sein.' }
                                ]}
                                hasFeedback
                            >
                                <Input.Password prefix={<LockOutlined />} placeholder="Mindestens 8 Zeichen" />
                            </Form.Item>

                            <Form.Item
                                name="passwordConfirm"
                                label="Passwort bestätigen"
                                dependencies={['password']}
                                hasFeedback
                                rules={[
                                    { required: true, message: 'Bitte bestätigen Sie Ihr Passwort.' },
                                    ({ getFieldValue }) => ({
                                        validator(_, value) {
                                            if (!value || getFieldValue('password') === value) {
                                                return Promise.resolve();
                                            }
                                            return Promise.reject(new Error('Die beiden Passwörter stimmen nicht überein!'));
                                        },
                                    }),
                                ]}
                            >
                                <Input.Password prefix={<LockOutlined />} placeholder="Passwort wiederholen" />
                            </Form.Item>

                            <Form.Item
                                name="acceptTerms"
                                valuePropName="checked"
                                rules={[
                                    {
                                        required: true,
                                        validator: (_, value) =>
                                            value ? Promise.resolve() : Promise.reject(new Error('Bitte akzeptieren Sie die Nutzungsbedingungen.')),
                                    },
                                ]}
                            >
                                <Checkbox>
                                     Ich akzeptiere die <Link to="/terms" target="_blank" rel="noopener noreferrer">Nutzungsbedingungen</Link> und <Link to="/privacy" target="_blank" rel="noopener noreferrer">Datenschutzrichtlinien</Link>.*
                                </Checkbox>
                            </Form.Item>

                            <Form.Item>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    loading={isSubmitting}
                                    block
                                >
                                    Registrieren
                                </Button>
                            </Form.Item>
                        </Form>

                         <Divider />

                         <div style={{ textAlign: 'center' }}>
                            <Paragraph>
                                 Bereits registriert? <Link to="/login">Hier anmelden</Link>
                             </Paragraph>
                            <Paragraph>
                                 Möchten Sie Ihren Shop eintragen? <Link to="/register">Shop registrieren</Link>
                             </Paragraph>
                         </div>
                    </Card>
                </Col>
            </Row>
        </Layout>
    );
};

export default UserRegistrationPage;